export const FREE_PLAY_TOOLTIP_DISPLAYED_NUMBER = 'orbit_free_play_tooltip_displayed_number';